import React, { useState } from 'react';
import {
  Box, IconButton, Tooltip, Menu, MenuItem, Divider,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FlagOutlinedIcon from '@mui/icons-material/FlagOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import * as C from '../../theme/colors.constants';

/**
 * Barra de ações acima do painel de detalhe.
 *
 * Reproduz a fileira do print: WhatsApp, bandeira, e-mail, um seletor, quatro
 * marcadores de cor preenchidos, cinco marcadores vazios (slots livres) e o
 * botão de copiar. As cores são as amostradas do print.
 */
const CORES = C.acaoColors;
const VAZIOS = 5;

export default function BarraAcoesProcesso() {
  const [ativas, setAtivas] = useState([]);
  const [anchor, setAnchor] = useState(null);

  const alternar = cor => setAtivas(a => (a.includes(cor) ? a.filter(x => x !== cor) : [...a, cor]));

  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 0.25, flexWrap: 'wrap', mb: 1, px: 0.5,
    }}
    >
      <Tooltip title="Enviar WhatsApp" arrow>
        <IconButton size="small" sx={{ color: '#25D366' }}><WhatsAppIcon fontSize="small" /></IconButton>
      </Tooltip>
      <Tooltip title="Marcar requisição" arrow>
        <IconButton size="small" sx={{ color: C.navy }}><FlagOutlinedIcon fontSize="small" /></IconButton>
      </Tooltip>
      <Tooltip title="Enviar e-mail" arrow>
        <IconButton size="small" sx={{ color: C.navy }}><EmailOutlinedIcon fontSize="small" /></IconButton>
      </Tooltip>

      <Tooltip title="Mais modelos de envio" arrow>
        <IconButton size="small" onClick={e => setAnchor(e.currentTarget)} sx={{ color: C.navy, ml: -0.5 }}>
          <ArrowDropDownIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchor} open={Boolean(anchor)} onClose={() => setAnchor(null)}>
        <MenuItem onClick={() => setAnchor(null)}>Notificação — modelo Normal</MenuItem>
        <MenuItem onClick={() => setAnchor(null)}>Notificação — modelo Especial</MenuItem>
        <Divider />
        <MenuItem onClick={() => setAnchor(null)}>Boleto / PIX</MenuItem>
      </Menu>

      <Divider orientation="vertical" flexItem sx={{ mx: 0.75, my: 0.5 }} />

      {/* Marcadores de cor preenchidos */}
      {CORES.map((cor) => {
        const ativa = ativas.includes(cor);
        return (
          <Tooltip key={cor} title={`Marcador ${cor}`} arrow>
            <Box
              role="button"
              tabIndex={0}
              aria-pressed={ativa}
              onClick={() => alternar(cor)}
              onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && alternar(cor)}
              sx={{
                width: 18,
                height: 18,
                borderRadius: '5px',
                mx: 0.25,
                backgroundColor: cor,
                cursor: 'pointer',
                outline: ativa ? `2px solid ${C.navy}` : 'none',
                outlineOffset: 1.5,
                '&:hover': { opacity: 0.8 },
              }}
            />
          </Tooltip>
        );
      })}

      {/* Slots vazios (mesma quantidade do print) */}
      {Array.from({ length: VAZIOS }).map((_, i) => (
        <Tooltip key={`vazio-${i}`} title="Marcador livre" arrow>
          <Box
            sx={{
              width: 18,
              height: 18,
              borderRadius: '50%',
              mx: 0.25,
              border: `1.5px solid ${C.borderGrey}`,
              cursor: 'pointer',
              '&:hover': { borderColor: C.navy },
            }}
          />
        </Tooltip>
      ))}

      <Divider orientation="vertical" flexItem sx={{ mx: 0.75, my: 0.5 }} />

      <Tooltip title="Copiar dados do processo" arrow>
        <IconButton size="small" sx={{ color: C.navy }}><ContentCopyIcon fontSize="small" /></IconButton>
      </Tooltip>
      <Tooltip title="Mais ações" arrow>
        <IconButton size="small" sx={{ color: C.navy, ml: -0.5 }}><ArrowDropDownIcon fontSize="small" /></IconButton>
      </Tooltip>
    </Box>
  );
}
